import React from 'react';
import styles from './ShareButton.module.scss';
import {MDBCol, MDBPopover, MDBPopoverBody, MDBRow} from 'mdbreact';
import {IconButton} from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
// @ts-ignore
import {
  FacebookIcon as F,
  FacebookMessengerIcon as FF,
  FacebookMessengerShareButton,
  FacebookShareButton,
  TwitterIcon as T,
  TwitterShareButton,
  WhatsappIcon as W,
  WhatsappShareButton,
} from 'react-share';
import useToggle from '@react-hook/toggle';
import {IProduct} from 'data/interfaces/products';
import {When} from 'react-if';
import {PRODUCT_STATUS_PUBLISHED} from 'data/redux/constants/productsConstants';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import {generateSluggedAdUrl} from 'data/redux/actions/guiActions';
import {getProductTitle} from "../../../Ad";
import {config} from "data/utils/constants";

const FacebookIcon: any = F;
const WhatsappIcon: any = W;
const FacebookMessengerIcon: any = FF;
const TwitterIcon: any = T;

interface IShareButtonProps {
  title?: string;
  product: Partial<IProduct>;
  children?: any;
  shareButtonClassName?: string;
  shareButtonText?: string;
  loading?: boolean;
}

const trimSlashes = str => str.split('/').filter(v => v !== '').join('/');

const ShareButton = ({loading, ...props}: IShareButtonProps) => {
  const [isOn, toggleIsOn] = useToggle(false, true, false);
  const url = props.product ? [location.origin, trimSlashes(generateSluggedAdUrl(props.product))].join('/') : window.location.href;
  const title = props.title || [getProductTitle(props as any), 'מחיר מציאה הכי זול בשוק'].join(' ');
  return loading ? <SkeletonPlaceHolder
    width={100} height={30}
    style={{float: "left"}}
  /> : (
    <When condition={[PRODUCT_STATUS_PUBLISHED].includes(props.product.status)}>
      {() => <MDBPopover
        placement="bottom"
        popover
        clickable
        isVisible={isOn}
      >
        {props.children ? props.children : <IconButton aria-label="share"
                                                       className={`${styles.shareButton} ${props.shareButtonClassName}`.trim()}
                                                       onClick={() => !isOn && toggleIsOn()}
        >
          <ShareIcon/>
          <span>{props.shareButtonText}</span>
        </IconButton>}
        <div>
          <MDBPopoverBody>
            <MDBRow>
              <MDBCol>
                <FacebookShareButton
                  url={url}
                  quote={title}
                  title={title}
                  translate={null}
                >
                  <FacebookIcon size={32} round/>
                </FacebookShareButton>
              </MDBCol>
              <MDBCol>
                <FacebookMessengerShareButton
                  url={url}
                  appId={config.facebook.appId}
                  title={title}
                  translate={null}
                >
                  <FacebookMessengerIcon size={32} round/>
                </FacebookMessengerShareButton>
              </MDBCol>
              <MDBCol>
                <WhatsappShareButton
                  url={url}
                  title={title}
                  separator=" "
                  translate={null}
                >
                  <WhatsappIcon size={32} round/>
                </WhatsappShareButton>
              </MDBCol>
              <MDBCol>
                <TwitterShareButton
                  url={url}
                  title={title}
                  translate={null}
                >
                  <TwitterIcon size={32} round/>
                </TwitterShareButton>
              </MDBCol>
            </MDBRow>
          </MDBPopoverBody>
        </div>
      </MDBPopover>}
    </When>
  );
}

ShareButton.defaultProps = {
  title: "",
  product: {status: PRODUCT_STATUS_PUBLISHED},
  shareButtonClassName: "",
  shareButtonText: 'שתף',
};
export default ShareButton;
